import { getCurrentPage, router } from '@router/index.js';
import { UIElement } from '@ui';
import * as Language from '@utils/language.js';
import MainLayout from './layouts/MainLayout.js';

// Import Tailwind CSS
// import 'choices.js/public/assets/styles/choices.min.css';
import { scrollstop } from '@utils/scrollstop.js';
import 'flatpickr/dist/themes/light.css';
import 'quill/dist/quill.core.css';
import './tailwind.css';

// Global cleanup function for proper memory management
const performGlobalCleanup = () => {
  try {
    const currentPage = getCurrentPage();

    if (currentPage && typeof currentPage.dispose === 'function') {
      currentPage.dispose();
    }
  } catch (error) {
    console.error('Error during global cleanup:', error);
  }
};

const initializeApp = async () => {
  Language.initialize(localStorage.getItem('selectedLanguage') || 'en');
  const APP = new UIElement(document.querySelector('#APP'));
  APP.add(MainLayout);

  window.addEventListener('popstate', router);

  // Add cleanup listeners for proper memory management
  window.addEventListener('beforeunload', performGlobalCleanup);
  window.addEventListener('pagehide', performGlobalCleanup);

  scrollstop();

  await router();
};

initializeApp();
